import React from 'react';
import { ForgeListItem } from '@tylertech/forge-react';
import { hasEmbeddedExecutionMethod } from '../helpers/tableActionsHelper';

interface TableActionsLinkItemProps {
  entry: any;
  index: number;
  onLinkClick: (url: string) => void;
}

export const TableActionsLinkItem = ({ entry, onLinkClick, index }: TableActionsLinkItemProps) => {
  const isEmbeddedExecution = hasEmbeddedExecutionMethod(entry);
  const aTagAttributes = isEmbeddedExecution
    ? { href: '#', onClick: () => onLinkClick(entry.url) }
    : { target: '_blank', rel: 'noopener noreferrer', href: entry.url };

  return (
    <ForgeListItem key={index}>
      <a {...aTagAttributes}>{entry.name}</a>
    </ForgeListItem>
  );
};
